// @flow
import * as React from 'react';
import TalkDetailItem from '../ListItem';
import parseDate from '../../utils/parseDate';

const Frontmatter = ({
  intro,
  slides,
  post,
  video,
  where,
  when,
  resources,
  title,
  children,
}: {
  title: string,
  intro: string,
  slides?: string,
  post?: string,
  video?: string,
  where?: {
    name: string,
    link: string,
  },
  when?: Date,
  resources?: { name: string, link: string }[],
  children?: React.Node,
}) => {
  const [maintitle, subtitle] = title.split('–');
  return (
    <>
      <section>
        <h1>{maintitle}</h1>
        <p>{subtitle && <em>–{subtitle}</em>}</p>
      </section>
      {!!intro && (
        <section className="background-fafafa italic padding-1-rem italic font-size-1-dot-2-em line-height-1-dot-4">
          {intro.split('\n').map((content, idx) => (
            <p key={`intro-paragraph-${idx}`}>{content}</p>
          ))}
        </section>
      )}
      <ul>
        {!!slides && (
          <li>
            <TalkDetailItem text="slides" link={slides} />
          </li>
        )}
        {!!post && (
          <li>
            <TalkDetailItem text="post" link={post} />
          </li>
        )}
        {!!video && (
          <li>
            <TalkDetailItem text="video" link={video} />
          </li>
        )}
        {!!where && (
          <li>
            <TalkDetailItem text={where.name} link={where.link} label="where" />
          </li>
        )}
        {!!when && (
          <li>
            <TalkDetailItem text={parseDate(when)} label="when" />
          </li>
        )}
      </ul>
      {resources && (
        <>
          <h3>Resources</h3>
          <ul>
            {resources.map(({ name, link }) => (
              <li key={`resource-${name}`}>
                <TalkDetailItem text={name} link={link} external />
              </li>
            ))}
          </ul>
        </>
      )}
      <hr />
      {children}
    </>
  );
};

export default Frontmatter;
